import { render, staticRenderFns } from "./BusinessScopeDetails.vue?vue&type=template&id=17fc7948&"
import script from "./BusinessScopeDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessScopeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports